import axios from 'config/axios';

const prefix = 'carsManagement';

export default class CarsManagementSrv {
  static getForGrid(dataState) {
    return axios
      .post(`${prefix}/getForGrid`, dataState)
      .then(result => result.data);
  }

  static get(instanceId) {
    return axios.get(`${prefix}/${instanceId}`).then(result => result.data);
  }

  static add(model) {
    return axios.post(prefix, model);
  }

  static update(model) {
    return axios.put(prefix, model);
  }

  static getCarTypesAsSelectItems() {
    return axios
      .get(`${prefix}/getCarTypesAsSelectItems`)
      .then(result => result.data);
  }

  static getCompaniesAsSelectItems() {
    return axios
      .get(`${prefix}/getCompaniesAsSelectItems`)
      .then(result => result.data);
  }
}
